import { Css, useTestIds } from "@homebound/beam";
import { observer } from "mobx-react";
import { useInsideMapsConfig } from "../hooks/useInsideMapsConfig";

export const CompletionIndicator = observer(function CompletionIndicator() {
  const store = useInsideMapsConfig();
  const tid = useTestIds({});
  const pct = store.completionPercentage;
  const pctColor = pct >= 80 ? Css.green600.$ : pct >= 50 ? Css.yellow600.$ : Css.red600.$;
  const barColor = pct >= 80 ? "#16a34a" : pct >= 50 ? "#ca8a04" : "#dc2626";

  const textureReviewPct =
    store.totalTextures > 0 ? Math.round((store.reviewedTextures / store.totalTextures) * 1000) / 10 : 0;
  const partsLocationPct =
    store.totalParts > 0 ? Math.round((store.partsWithLocations / store.totalParts) * 1000) / 10 : 0;

  return (
    <div {...tid.completionIndicator}>
      <div css={Css.df.aic.gap1.mb1.$}>
        <span css={Css.smSb.$}>Completion Status</span>
        <span css={Css.md.gray500.$}>&oslash;</span>
        <span css={Css.smSb.add("color", barColor).$}>{pct}%</span>
      </div>

      {/* Overall Progress */}
      <div css={Css.df.aic.jcsb.mb1.$}>
        <span css={Css.xs.gray600.$}>Overall Progress</span>
        <span css={Css.xs.add("color", barColor).$}>{pct}%</span>
      </div>
      <div css={Css.w100.hPx(8).bgGray200.br4.oh.mb2.$}>
        <div css={Css.hPx(8).br4.add("width", `${pct}%`).add("backgroundColor", barColor).$} />
      </div>

      {/* Stats grid */}
      <div css={Css.df.gap2.mb2.$}>
        <div css={Css.fg1.$}>
          <div css={Css.xs.gray600.$}>Textures</div>
          <div css={Css.df.aic.gap1.$}>
            <span css={Css.smSb.blue700.$}>{store.reviewedTextures}</span>
            <span css={Css.xs.gray500.$}>/ {store.totalTextures}</span>
          </div>
          <div css={Css.xs.gray500.$}>{textureReviewPct}% reviewed</div>
        </div>
        <div css={Css.fg1.$}>
          <div css={Css.xs.gray600.$}>Parts</div>
          <div css={Css.df.aic.gap1.$}>
            <span css={Css.smSb.blue700.$}>{store.partsWithLocations}</span>
            <span css={Css.xs.gray500.$}>/ {store.totalParts}</span>
          </div>
          <div css={Css.xs.gray500.$}>{partsLocationPct}% with locations</div>
        </div>
      </div>

      <div css={Css.df.gap2.$}>
        <div css={Css.fg1.$}>
          <div css={Css.xs.gray600.$}>Cameras</div>
          <div css={Css.df.aic.gap1.$}>
            <span css={Css.smSb.blue700.$}>{store.camerasWithLocation}</span>
            <span css={Css.xs.gray500.$}>/ {store.cameras.length}</span>
          </div>
          <div css={Css.xs.gray500.$}>with location</div>
        </div>
      </div>
    </div>
  );
});
